module.exports = __webpack_public_path__ + "static/media/ventil_richtig.3e1bc87a.jpg";